import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './styles/variables.scss';
import { Toast, Lazyload } from 'vant';
import VueCookies from 'vue-cookies';
import Vconsole from 'vconsole';
import wx from 'weixin-js-sdk';
import { NavigationGuardNext } from 'vue-router';
import vueCookies from 'vue-cookies';

process.env.VUE_APP_MODE === 'test' && new Vconsole();

const loginEndJump = (needLogin: boolean, next: NavigationGuardNext) => {
  const { whetherShow, isTourist } = store.state.user;
  if (whetherShow) {
    needLogin && isTourist === 1 ? next('/login') : next();
  } else {
    next('/store-error');
  }
};

router.beforeEach((to, from, next) => {
  wx.ready(() => wx.hideAllNonBaseMenuItem());

  document.title = <string>to.name || 'biocare';
  const needLogin = !!to.meta.auth;

  const customerId = store.state.user.customerId;

  if (store.getters['user/getToken']) {
    if (customerId > 0) {
      loginEndJump(needLogin, next);
    } else {
      store.dispatch('user/ACTION_GET_USER_INFO').then(() => loginEndJump(needLogin, next));
    }
  } else {
    store
      .dispatch('user/ACTION_LOGIN', { isTourist: 1, storeId: store.state.user.storeId })
      .then(() => next());
  }
});

const init = () => {
  const oldStoreId = (vueCookies as any).get('storeId') || '';
  store.commit('user/SET_USER_STORE_ID', oldStoreId);
  const { pathname, search } = window.location;
  const whiteList = ['/service/detail/project/', '/service/detail/card/', '/appointment'];
  const have = whiteList.some((item) => pathname.indexOf(item) > -1);
  if ((['/'].includes(pathname) || have) && search) {
    const _search = Object.fromEntries(
      search
        .substring(1)
        .split('&')
        .map((item) => item.split('='))
    );
    const storeId = _search.storeId || '';
    if (storeId !== oldStoreId) {
      store.commit('user/SET_USER_STORE_ID', storeId);
      store.commit('user/SET_TOKEN', '');
    }
  }
};
init();

createApp(App)
  .use(Toast)
  .use(VueCookies, { expire: '7d' })
  .use(Lazyload)
  .use(store)
  .use(router)
  .mount('#app');
